import { useTranslation } from 'react-i18next';
import { Button, Icon, Link } from '@vp/swan';
import { sanitiseLocale } from '../../i18n/config';
import { logomakerCtaPathByLocale } from '../../utils/urls';
import EditWrapper from '../EditWrapper/EditWrapper';

type LogomakerCTAProps = {
    ctaRef?: (node: HTMLElement) => void;
};

const LogomakerCTA = ({ ctaRef }: LogomakerCTAProps) => {
    const { t, i18n } = useTranslation();
    const locale = sanitiseLocale(i18n.language);

    const handleClick = () => {
        // The Logomaker wizard needs this flag to clear the IndexedDB for it's functionality
        sessionStorage.setItem('isReloaded', 'false');
    };

    return (
        <EditWrapper url={t('Logomaker landing page > Start Creating Link.editUrl')}>
            <Button
                skin="primary"
                textAlign="center"
                render={(props) => (
                    <Link
                        to={logomakerCtaPathByLocale(locale)}
                        className={props.className}
                        onClick={handleClick}
                        ref={ctaRef}
                    >
                        {props.children}
                    </Link>
                )}
            >
                {t('Logomaker landing page > Start Creating Link.text')}
                <Icon alt="next step" iconType="magic" />
            </Button>
        </EditWrapper>
    );
};

export default LogomakerCTA;
